import { isDevFlagEnabled } from 'common/components/DevFlag';

export const CAMPAIGNS = '/campaigns';
export const ALLCAMPAIGNS = '/all-campaigns';
export const CAMPAIGN = (id: string) => `/campaign/${id}`;
export const INVOICING = '/invoicing';
export const STREAMING = '/streams';
export const STREAM = (id: string) => `/streams/${id}`;
export const DASHBOARD = isDevFlagEnabled('UI_V2') ? '/dashboard-v2' : '/dashboard';
export const REACH = isDevFlagEnabled('METRICS_V2') ? '/reach-v2' : '/reach';



// WEBPACK FOOTER //
// ./src/statsradio/helpers/constant/Routes.js